import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { SummaryTableSkeleton } from './stepSkeletonParts';

/** Krok W3 — podgląd strony klienta i panele objaśnień. */
const ChangePackageAcceptanceStepSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex flex-col items-stretch gap-[22px] min-[1200px]:flex-row min-[1200px]:items-start',
      className,
    )}
    {...props}
  >
    <Card className="@container w-full max-w-[880px] overflow-hidden min-[1200px]:shrink-0">
      <div className="@max-[700px]:px-4 flex items-center gap-3 bg-ink px-[26px] py-5">
        <Skeleton className="h-4 w-28 bg-neutral-700" />
        <Skeleton className="ml-auto h-3 w-32 bg-neutral-700" />
      </div>

      <div className="@max-[700px]:px-4 px-[26px] pb-5 pt-[26px]">
        <Skeleton className="h-6 w-[420px] max-w-full" />
        <Skeleton className="mt-2 h-4 w-full" />
      </div>

      <SummaryTableSkeleton />

      <Skeleton className="@max-[700px]:mx-4 mx-[26px] mt-4 h-[86px] rounded-[11px]" />
      <Skeleton className="@max-[700px]:mx-4 mx-[26px] mt-4 h-[120px] rounded-[11px]" />

      <div className="@max-[940px]:flex-col @max-[940px]:items-stretch @max-[700px]:px-4 flex items-center gap-3 px-[26px] pb-6 pt-5">
        <Skeleton className="@max-[940px]:w-full h-12 w-64 rounded-[9px]" />
        <Skeleton className="@max-[940px]:w-full h-12 w-36 rounded-[9px]" />
        <Skeleton className="@max-[940px]:ml-0 ml-auto h-3 w-32" />
      </div>
    </Card>

    <div className="flex min-w-0 flex-1 flex-col gap-4">
      {Array.from({ length: 2 }, (_, index) => (
        <Card key={index} className="overflow-hidden">
          <div className="border-b border-neutral-100 px-5 pb-3.5 pt-4">
            <Skeleton className="h-3 w-40" />
          </div>
          <div className="flex flex-col gap-3.5 px-5 pb-[18px] pt-4">
            <Skeleton className="h-14 w-full rounded-[10px]" />
            <Skeleton className="h-16 w-full" />
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default ChangePackageAcceptanceStepSkeleton;
